"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var UserNameInput_vue_1 = __importDefault(require("../form/UserNameInput.vue"));
var EmailAddressInput_vue_1 = __importDefault(require("../form/EmailAddressInput.vue"));
var RoleMultiselect_vue_1 = __importDefault(require("../form/RoleMultiselect.vue"));
var VInlineInputEditor_vue_1 = __importDefault(require("../scraps/VInlineInputEditor.vue"));
var VInlineDropdownMultiselectEditor_vue_1 = __importDefault(require("../scraps/VInlineDropdownMultiselectEditor.vue"));
var event_bus_1 = require("../../event-bus");
var permissions_json_1 = __importDefault(require("../../../permissions.json"));
var VIcon_vue_1 = __importDefault(require("../scraps/VIcon.vue"));
var DeleteUser_vue_1 = __importDefault(require("./DeleteUser.vue"));
var DistrictMultiselect_vue_1 = __importDefault(require("../form/DistrictMultiselect.vue"));
var UnitMultiselect_vue_1 = __importDefault(require("../form/UnitMultiselect.vue"));
var __ = window.$lang;
exports.default = vue_1.default.extend({
    name: "users-table",
    components: {
        DeleteUser: DeleteUser_vue_1.default,
        VInlineInputEditor: VInlineInputEditor_vue_1.default,
        VInlineDropdownMultiselectEditor: VInlineDropdownMultiselectEditor_vue_1.default,
        VIcon: VIcon_vue_1.default
    },
    props: {
        users: {
            type: Array,
            required: true
        },
        roles: {
            type: Array,
            required: true
        },
        districts: {
            type: Array,
            required: true
        },
        units: {
            type: Array,
            required: true
        },
        pagination: {
            type: Object,
            required: true
        }
    },
    data: function () {
        return {
            permissions: permissions_json_1.default,
            headers: [
                __("Lp."),
                __("Nazwa użytkownika"),
                __("Adres e-mail"),
                __("Role"),
                __("Hufce"),
                __("Jednostki"),
                __("Akcje")
            ],
            components: {
                UserNameInput: UserNameInput_vue_1.default,
                EmailAddressInput: EmailAddressInput_vue_1.default,
                RoleMultiselect: RoleMultiselect_vue_1.default,
                DistrictMultiselect: DistrictMultiselect_vue_1.default,
                UnitMultiselect: UnitMultiselect_vue_1.default
            }
        };
    },
    methods: {
        onUserUpdate: function (user_id, attribute, value) {
            event_bus_1.EventBus.$emit(event_bus_1.events.user.update, {
                id: user_id,
                attribute: attribute,
                value: value
            });
        }
    }
});
